import { Chip } from '@mui/material';

const COLORS: Record<string, 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'info'> = {
  draft: 'default',
  published: 'info',
  in_progress: 'warning',
  complete: 'success',
  cancelled: 'error',
  registered: 'info',
  scratched: 'default',
  dns: 'warning',
  dnf: 'warning',
  dq: 'error',
  pending: 'warning',
  accepted: 'success',
  revoked: 'error',
  expired: 'default',
  queued: 'default',
  sent: 'success',
  failed: 'error',
};

const LABELS: Record<string, string> = {
  draft: 'Draft',
  published: 'Published',
  in_progress: 'In progress',
  complete: 'Complete',
  cancelled: 'Cancelled',
  registered: 'Registered',
  scratched: 'Scratched',
  dns: 'DNS',
  dnf: 'DNF',
  dq: 'DQ',
  pending: 'Pending',
  accepted: 'Accepted',
  revoked: 'Revoked',
  expired: 'Expired',
  queued: 'Queued',
  sent: 'Sent',
  failed: 'Failed',
};

export default function StatusChip({ status }: { status: string }) {
  return (
    <Chip
      label={LABELS[status] ?? status}
      color={COLORS[status] ?? 'default'}
      size="small"
      variant={COLORS[status] === 'default' ? 'outlined' : 'filled'}
    />
  );
}
